// Noms des champs des formulaires (fusion des champs Salesforce et autres inputs)
export const FORM_FIELDS = {
	LASTNAME: process.env.NEXT_PUBLIC_SF_LASTNAME_ID, // Nom
	FIRSTNAME: process.env.NEXT_PUBLIC_SF_FIRSTNAME_ID, // Prénom
	STREET: process.env.NEXT_PUBLIC_SF_STREET_ID, // Rue
	CITY: process.env.NEXT_PUBLIC_SF_CITY_ID, // Ville
	POSTCODE: process.env.NEXT_PUBLIC_SF_POSTCODE_ID, // Code postal
	ACCOUNT_ID: process.env.NEXT_PUBLIC_SF_ACCOUNT_ID_ID, // ID Salesforce
	CONSENT_GDPR: process.env.NEXT_PUBLIC_SF_CONSENT_GDPR_ID, // Consentement RGPD
	CONSENT_EMAIL: process.env.NEXT_PUBLIC_SF_CONSENT_EMAIL_ID, // Consentement Email
	CONSENT_PHONE: process.env.NEXT_PUBLIC_SF_CONSENT_PHONE_ID, // Consentement Téléphone
	ACQUISITION_CHANNEL: process.env.NEXT_PUBLIC_SF_ACQUISITION_CHANNEL_ID, // Canal d'acquisition
	PHONE_INDICATOR: process.env.NEXT_PUBLIC_SF_PHONE_INDICATOR_ID, // Indicatif téléphonique
	EMAIL: "email",
	PHONE: "phone",
	ADDRESS: "adresse",
	MESSAGE: "description",
	ORGID: "orgid",
	RECORD_TYPE: "recordType",
	SUBJECT: "subject",
	TYPE: "type",
	PRIORITY: "priority",
	ENCODING: "encoding",
} as const;
